// extracted by mini-css-extract-plugin
export default {"scouting-red":"PersonToggle__scouting-red___V0QUb","large":"PersonToggle__large___M5mdw"};